(function () {

    "use strict";

    angular
        .module("harriApp")
        .service("dependenciesLoaderService", DependenciesLazyLoader);

    DependenciesLazyLoader.$inject = ['$q'];

    function DependenciesLazyLoader($q) {
        var self = this;

        self.load = function (dependencies) {
            var promises = [];

            dependencies = dependencies || [];

            dependencies.forEach(function (dependencyConfig) {
                var defer = $q.defer();

                switch (dependencyConfig.type) {
                    case 'chunk':
                        dependencyConfig.loader()
                            .catch(function (err) {
                                console.error("Error while loading:", dependencyConfig);
                                console.error(err);
                            })
                            .finally(function () {
                                // Always resolve, don't block the route
                                defer.resolve();
                            });

                        break;

                    case 'library':
                    default:
                        System.import(dependencyConfig.path)
                            .then(function (result) {

                                if (dependencyConfig.type === 'library' && dependencyConfig.name) {
                                    window[dependencyConfig.name] = result;
                                }

                                defer.resolve(result);
                            })
                            .catch(function (err) {
                                console.error(err);
                                // Always resolve, don't block the route
                                defer.resolve();
                            });
                        break;

                }

                promises.push(defer.promise);
            });

            return $q.all(promises);
        }

    };
})();
